
<!-- Объекты-аналоги -->

<template>

<base_objects
	ref="objects"
	essence="ОА"
	:service="service"
	single_element_url="analogues"
	with_delete_many
	with_group
	:keys_if_all_attrs_hidden="default_attrs"
	:essence_name_many="'объекты-аналоги'"
	:additional_query="{ 'current_version.attrs.analogue_profitable_type' : 'Купля-продажа' }"
	:without_edit_many="!check_roles([ 'grouping', 'model' ])"
/>

</template>

<script>

import api from "../../../api"
import base_objects from "../base_objects"
//import sub_menu from "../../widgets/sub_menu"

export default
{
	components :
	{
		base_objects,
		//sub_menu,
	},

	data()
	{
		return {

			service : "cadastral_analogues",

		}
	},

	computed:
	{
		default_attrs()
		{
			const default_attrs1 = [ 'attrs.CadastralNumber', 'attrs.group_code' ]
			const default_attrs2 = [
				"attrs.corrected_price",
				"attrs.ReadableAddress"
			]
			
			return api.has_oks()
				? [
					...default_attrs1,
					"attrs.ObjectType", "attrs.functional_group",
					// "attrs.2b1851301d59c7915d3db4928ba479d63c4b73acf60c6aa1016c298627c0b05b",	// Тип сделки
					...default_attrs2
				]
				: [
					...default_attrs1,
					"attrs.Segment",
					// "attrs.0da9bb795297cd3449f991233fdffe0b584c715394df25020c9bb99335680b3c",	// Тип сделки
					...default_attrs2
				]
		}
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},
	},
}

</script>

